import {
  FileText, Building2, Globe2, Plane, Briefcase, ShieldCheck, Clock,
  Lock, Zap, Award, HeartHandshake,
} from "lucide-react";

export const WHATSAPP_NUMBER = "22873195241";
export const PHONE_DISPLAY = "+228 73 19 52 41";
export const PHONE_TEL = "tel:+22873195241";
export const WHATSAPP_URL = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Bonjour DOC TOGO, je souhaite être accompagné(e) pour une démarche au Togo."
)}`;
export const CONTACT_EMAIL = "contact@doc-togo.com";

export const IMAGES = {
  hero: "https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  heroSecondary: "https://images.unsplash.com/photo-1553697388-94e804e2f0f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=900",
  business: "https://images.unsplash.com/photo-1573164574511-73c773193279?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  documents: "https://images.unsplash.com/photo-1553697388-94e804e2f0f6?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  lome: "https://images.pexels.com/photos/32803403/pexels-photo-32803403.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
  diaspora: "https://images.unsplash.com/photo-1655720357872-ce227e4164ba?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200",
  africa: "https://images.pexels.com/photos/8729928/pexels-photo-8729928.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940",
};

export const SERVICES = [
  {
    id: "documents-administratifs",
    icon: FileText,
    title: "Documents administratifs",
    short: "Passeport, CNI, casier judiciaire, état civil, permis de conduire, visa et plus encore.",
    items: [
      "Passeport togolais",
      "Carte Nationale d'Identité (CNI)",
      "Casier judiciaire",
      "Actes de naissance & documents d'état civil",
      "Permis de conduire",
      "Sauf-conduit",
      "Visa & formalités liées au séjour",
      "Autres démarches administratives",
    ],
    image: IMAGES.documents,
  },
  {
    id: "creation-entreprise",
    icon: Building2,
    title: "Création d'entreprise",
    short: "De l'idée à l'immatriculation : nous créons votre société au Togo de bout en bout.",
    items: [
      "Orientation sur la forme juridique",
      "Constitution du dossier",
      "Formalités de création (CFE)",
      "Immatriculation NIF & RCCM",
      "Documents constitutifs",
      "Formalités post-création",
      "Accompagnement entrepreneurs & investisseurs",
    ],
    image: IMAGES.business,
    link: "/creation-entreprise",
  },
  {
    id: "diaspora",
    icon: Globe2,
    title: "Services diaspora",
    short: "Vos démarches au Togo sans déplacement : nous agissons pour vous, où que vous soyez.",
    items: [
      "Démarches réalisées à distance",
      "Représentation administrative au Togo",
      "Suivi de dossiers en temps réel",
      "Projets immobiliers & vérifications foncières",
      "Légalisation & apostille de documents",
    ],
    image: IMAGES.diaspora,
    link: "/diaspora",
  },
  {
    id: "etrangers",
    icon: Plane,
    title: "Services étrangers",
    short: "Visiter, travailler, investir ou s'installer au Togo en toute sérénité.",
    items: [
      "Visa d'entrée & prolongation de séjour",
      "Carte de séjour temporaire / permanente",
      "Formalités d'installation & mobilité",
      "Investissement & création de filiale",
      "Accompagnement administratif complet",
    ],
    image: IMAGES.lome,
    link: "/etrangers",
  },
  {
    id: "entreprises",
    icon: Briefcase,
    title: "Services aux entreprises",
    short: "Assistance administrative, constitution et suivi de dossiers pour PME et organisations.",
    items: [
      "Assistance administrative courante",
      "Constitution & suivi de dossiers",
      "Formalités auprès des administrations",
      "Accompagnement des dirigeants vivant à l'étranger",
    ],
    image: IMAGES.africa,
  },
];

export const STEPS = [
  { num: "01", title: "Décrivez votre besoin", desc: "Remplissez le formulaire en 2 minutes ou écrivez-nous sur WhatsApp. Dites-nous simplement ce dont vous avez besoin." },
  { num: "02", title: "Recevez les informations & conditions", desc: "Sous 24h, vous recevez la liste exacte des pièces requises, les délais estimés et un devis clair, sans surprise." },
  { num: "03", title: "Préparez & transmettez vos documents", desc: "Envoyez vos pièces via notre formulaire sécurisé ou WhatsApp. Nous vérifions la conformité de chaque document." },
  { num: "04", title: "DOC TOGO traite & suit votre démarche", desc: "Nos équipes déposent, relancent et suivent votre dossier auprès des administrations. Vous êtes informé à chaque étape." },
  { num: "05", title: "Recevez votre document ou résultat", desc: "Retrait en main propre, en agence ou envoi sécurisé à l'international. Votre démarche aboutit, où que vous soyez." },
];

export const VALUES = [
  { icon: Zap, title: "Simplicité", desc: "Un parcours clair, un langage simple, zéro jargon administratif." },
  { icon: ShieldCheck, title: "Fiabilité", desc: "Chaque dossier est suivi jusqu'au bout, avec preuves à l'appui." },
  { icon: FileText, title: "Transparence", desc: "Devis détaillé avant tout engagement. Pas de frais cachés." },
  { icon: Lock, title: "Confidentialité", desc: "Vos documents et données sont protégés et jamais partagés." },
  { icon: Clock, title: "Réactivité", desc: "Réponse sous 24h ouvrées, suivi en temps réel de votre dossier." },
  { icon: Award, title: "Professionnalisme", desc: "Une équipe expérimentée, au fait des procédures togolaises." },
];

export const TESTIMONIALS = [
  {
    name: "Kossi A.",
    role: "Diaspora — Paris, France",
    text: "J'ai obtenu mon passeport et mon casier judiciaire sans quitter Paris. Suivi impeccable, délais respectés. Je recommande vivement.",
  },
  {
    name: "Aïcha B.",
    role: "Entrepreneure — Lomé, Togo",
    text: "Ma SARL a été créée en quelques jours : RCCM, NIF, statuts, tout était prêt. Un accompagnement professionnel du début à la fin.",
  },
  {
    name: "Marc D.",
    role: "Investisseur — Bruxelles, Belgique",
    text: "Pour m'installer et investir au Togo, DOC TOGO a géré le visa, la carte de séjour et la création de ma filiale. Efficace et rassurant.",
  },
];

export const FAQ_ITEMS = [
  {
    q: "Comment puis-je effectuer une démarche depuis l'étranger ?",
    a: "C'est notre spécialité. Vous décrivez votre besoin via le formulaire ou WhatsApp, vous nous transmettez vos pièces par voie numérique sécurisée, et nous traitons le dossier sur place au Togo. Vous recevez ensuite votre document original par courrier express sécurisé ou le récupérez via un proche mandaté.",
  },
  {
    q: "Quels sont les délais moyens de traitement ?",
    a: "Les délais varient selon la démarche : de 72h pour certains actes d'état civil à 2-4 semaines pour un passeport ou une création d'entreprise complète. Un calendrier précis vous est communiqué dès l'étude de votre demande, et vous êtes informé à chaque étape.",
  },
  {
    q: "Combien coûte l'accompagnement DOC TOGO ?",
    a: "Chaque demande fait l'objet d'un devis clair et détaillé avant tout engagement : frais administratifs officiels + honoraires d'accompagnement. Aucun frais caché, aucun paiement avant validation du devis.",
  },
  {
    q: "Mes données et documents sont-ils en sécurité ?",
    a: "Oui. Vos pièces sont transmises via un formulaire sécurisé et stockées de manière chiffrée. Elles sont utilisées uniquement dans le cadre strict de votre démarche et ne sont jamais partagées avec des tiers.",
  },
  {
    q: "Quels sont les modes de paiement acceptés ?",
    a: "Mobile Money (T-Money, Moov Money), virements bancaires nationaux et internationaux, ainsi que cartes bancaires (Visa / Mastercard). Les modalités exactes figurent sur votre devis.",
  },
  {
    q: "Puis-je suivre l'avancement de mon dossier ?",
    a: "Absolument. Chaque demande reçoit une référence unique. Vous êtes notifié à chaque étape clé par email ou WhatsApp, et vous pouvez nous contacter à tout moment pour un point d'avancement.",
  },
  {
    q: "DOC TOGO est-il une administration publique ?",
    a: "Non. DOC TOGO est une plateforme privée d'accompagnement et d'assistance administrative. Nous préparons, déposons et suivons vos dossiers auprès des administrations compétentes, en toute légalité, pour vous faire gagner du temps et éviter les erreurs.",
  },
  {
    q: "Je veux créer une entreprise au Togo sans y résider, est-ce possible ?",
    a: "Oui. Nous accompagnons régulièrement des entrepreneurs de la diaspora et des investisseurs étrangers : choix de la forme juridique, rédaction des statuts, immatriculation au CFE, obtention du RCCM et du NIF — le tout pouvant être piloté à distance.",
  },
  {
    q: "Quels documents dois-je fournir pour commencer ?",
    a: "Cela dépend de votre démarche. Décrivez-nous votre besoin : vous recevrez sous 24h la liste exacte et à jour des pièces requises, ainsi que les formats acceptés (scans, photos lisibles, originaux si nécessaire).",
  },
  {
    q: "Intervenez-vous aussi pour les entreprises établies ?",
    a: "Oui. Nous assistons PME et organisations pour leurs formalités courantes : modifications statutaires, renouvellements, conformité administrative, suivi de dossiers auprès des administrations et accompagnement des dirigeants basés à l'étranger.",
  },
];

export const MARQUEE_ITEMS = [
  "Passeport", "CNI", "Création d'entreprise", "Casier judiciaire", "Visa & séjour",
  "Sauf-conduit", "Actes d'état civil", "Immatriculation RCCM", "Permis de conduire", "Carte de séjour",
];

export const FORM_SERVICES = {
  "Documents administratifs": [
    "Passeport togolais",
    "Carte Nationale d'Identité (CNI)",
    "Casier judiciaire",
    "Actes de naissance & documents d'état civil",
    "Permis de conduire",
    "Sauf-conduit",
    "Visa & formalités liées au séjour",
    "Autre démarche administrative",
  ],
  "Création d'entreprise": [
    "Orientation sur la forme juridique",
    "Constitution du dossier",
    "Formalités de création (CFE)",
    "Immatriculation NIF & RCCM",
    "Documents constitutifs",
    "Formalités post-création",
    "Accompagnement entrepreneur / investisseur",
  ],
  "Services diaspora": [
    "Démarche à distance",
    "Représentation administrative au Togo",
    "Projet immobilier & vérification foncière",
    "Légalisation & apostille",
    "Autre demande diaspora",
  ],
  "Services étrangers": [
    "Visa d'entrée & prolongation",
    "Carte de séjour",
    "Installation au Togo",
    "Investissement & création de filiale",
    "Autre demande",
  ],
  "Services entreprises": [
    "Assistance administrative",
    "Constitution & suivi de dossiers",
    "Formalités auprès des administrations",
    "Accompagnement dirigeant à l'étranger",
  ],
  "Autre besoin": ["Je ne sais pas encore — je souhaite être conseillé(e)"],
};

export const PROFILS = [
  "Diaspora togolaise",
  "Résident(e) au Togo",
  "Étranger(ère) souhaitant venir au Togo",
  "Entrepreneur / Investisseur",
  "Entreprise / Organisation",
];

export const WHY_POINTS = [
  {
    icon: HeartHandshake,
    title: "Un interlocuteur unique",
    desc: "Fini les files d'attente et les allers-retours. Un conseiller dédié pilote votre dossier de A à Z.",
  },
  {
    icon: Globe2,
    title: "Pensé pour la diaspora",
    desc: "90% des démarches réalisables à distance. Vous suivez tout depuis votre téléphone, où que vous viviez.",
  },
  {
    icon: ShieldCheck,
    title: "Zéro mauvaise surprise",
    desc: "Devis avant engagement, délais annoncés et respectés, documents officiels vérifiés avant remise.",
  },
];
